module.exports = __webpack_public_path__ + "linea-basic-10.e4de528c00da0c081906.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/assets/linea/fonts/linea-basic-10.eot
// module id = ../../../../../src/assets/linea/fonts/linea-basic-10.eot
// module chunks = styles